import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const PMSOrganizationCustomizationTemplateStore = GenericFieldFactory(
    "PMS_ORGANIZATION_CUSTOMIZATION_TEMPLATE",
);
